// extracted by mini-css-extract-plugin
export default {"private-note":"PrivateNote_private-note__fTzBb"};